import React, { useEffect, useState } from 'react'
import { View, ViewStyle } from 'react-native'
import { observer } from 'mobx-react-lite'
import { useHistory, useRouteMatch } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { color, Header, iconArrowBack, TabController } from '@trivie/ui-mobile'
import { ContestTab } from './contest-tab'

export interface ContestScreenProps {}

export const ContestsScreen: React.FunctionComponent<ContestScreenProps> = observer((props) => {
  const { contestStore, userStore } = useStores()
  const { user } = userStore
  const { contestsForUser, getContestsForUser } = contestStore

  const { params } = useRouteMatch() as any
  const { contestID } = params

  const history = useHistory()

  const goToInfo = (id) => history.push(`/play/contests/${id}/info`)
  const goToPlay = () => history.push('/play')

  const load = async (id) => {
    if (user) {
      getContestsForUser(user.id)
    }
  }

  const [tabs, setTabs] = useState<any>(
    contestsForUser?.map((contest) => {
      return {
        id: contest?.id,
        name: contest?.title,
        enabled: true,
        label: contest?.title,
        onPress: () => {
          history.push(`/play/contests/${contest?.id}`)
          load(contest?.id)
        },
      }
    }),
  )

  const [activeTab, setActiveTab] = useState(0)

  useEffect(() => {
    let active = 0
    if (contestID) {
      active = Number(contestID)
    } else if (contestsForUser?.length > 0) {
      history.push(`/play/contests/${contestsForUser[0].id}/`)
      setActiveTab(contestsForUser[0].id)
    } else {
      history.goBack()
    }
    setActiveTab(active)
  }, [contestID])

  useEffect(() => {
    load(contestID ? contestID : contestsForUser[0].id)
  }, [])

  return (
    <View style={FULL}>
      <View style={CONTAINER}>
        <div style={HEADER_STICKY_CONTAINER}>
          <div style={HEADER_FLEX_CONTAINER}>
            <div style={HEADER_ITEM}>
              <Header
                leftIcon={iconArrowBack}
                onLeftPress={goToPlay}
                center
                headerTx={'Contests.header'}
              />
            </div>
          </div>
        </div>
        {tabs && (
          <TabController matchID setActiveTab={setActiveTab} activeTab={activeTab} tabs={tabs} />
        )}
        {contestsForUser?.map((contest) => {
          return contest?.id === activeTab ? (
            <ContestTab contest={contest} goToInfo={() => goToInfo(contest?.id)} />
          ) : null
        })}
      </View>
    </View>
  )
})

/**
 * Styling
 */
const FULL: ViewStyle = { flex: 1, height: '100%' }
const CONTAINER: ViewStyle = { backgroundColor: color.white, height: '100%' }
const HEADER_STICKY_CONTAINER: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  width: '100%',
  zIndex: 99,
  backgroundColor: 'white',
}
const HEADER_FLEX_CONTAINER: React.CSSProperties = {
  display: 'flex',
  maxWidth: '1440px',
  justifyContent: 'space-between',
}
const HEADER_ITEM: React.CSSProperties = {
  width: '100%',
}
